var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScotia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8867 12.9672H24.5963C18.7271 12.9672 13.8941 17.2633 13.2632 22.7871H13.2615C12.3581 21.2045 11.8438 19.3843 11.8438 17.4477C11.8438 11.3463 16.9487 6.40002 23.2462 6.40002H41.0038L34.8867 12.9672Z",
    fill: "#EC111A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2968 35.0329H24.5872C30.4564 35.0329 35.2898 30.7368 35.9199 25.213H35.922C36.8254 26.7956 37.3397 28.6157 37.3397 30.5524C37.3397 36.6538 32.2347 41.6 25.9373 41.6H8.17969L14.2968 35.0329Z",
    fill: "#EC111A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7755 24.0001C33.7755 28.9081 29.664 32.8867 24.5919 32.8867C19.5198 32.8867 15.4082 28.9081 15.4082 24.0001C15.4082 19.092 19.5198 15.1134 24.5919 15.1134C29.664 15.1134 33.7755 19.092 33.7755 24.0001Z",
    fill: "#EC111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScotia);
export default __webpack_public_path__ + "static/media/scotia.5bc1bcdfe423029588d8cff298c9f73f.svg";
export { ForwardRef as ReactComponent };